import { render, staticRenderFns } from "./daily-office-quick.vue?vue&type=template&id=f07475a4&scoped=true"
import script from "./daily-office-quick.vue?vue&type=script&lang=js"
export * from "./daily-office-quick.vue?vue&type=script&lang=js"
import style0 from "./daily-office-quick.vue?vue&type=style&index=0&id=f07475a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07475a4",
  null
  
)

export default component.exports